var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopContent'),_c('LffServices'),_c('LffHardSkills'),_c('LffSeparator'),_c('LffSoftSkills'),_c('LffAboutMe'),_c('LffProjects'),_c('LffPreFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }